import { FC, useCallback, useEffect, useState } from 'react';
import {
    BulkAddProductsToSelectionListResponse,
    BulkAddProductsToShoppingCartResponse,
    BundleOut
} from '../../store/api';
import { AppDispatch } from '../../store';
import { PriceTier } from '../../../models/PriceTier';
import { Orderlist } from '../../../models/OrderList';
import { BundleHeader } from './BundleHeader';
import { isEmptyProductFilters, useProductFilters } from '../filter/useProductFilters';
import { SubscriptionPeriodType } from '../../../models/Article';

type Props = {
    readonly bundle: BundleOut & { price?: number };
    readonly orderlist?: Orderlist;
    readonly orderlists: ReadonlyArray<Orderlist>;
    readonly onAddBundleToList: (
        orderList: Orderlist,
        priceTier: PriceTier,
        subscriptionPeriodType: SubscriptionPeriodType,
        performChecks: boolean
    ) => Promise<BulkAddProductsToSelectionListResponse>;
    readonly onAddBundleToCart: (
        priceTier: PriceTier,
        subscriptionPeriodType: SubscriptionPeriodType,
        performChecks: boolean
    ) => Promise<BulkAddProductsToShoppingCartResponse>;
    readonly onCreateNewListClicked?: (newListName: string) => void;
    readonly dispatch: AppDispatch;
};

const DetailHeader: FC<Props> = ({
    onAddBundleToList,
    onAddBundleToCart,
    bundle,
    orderlists,
    onCreateNewListClicked
}) => {
    const [filtered, setFiltered] = useState(false);
    const { filters } = useProductFilters();
    const isBundleFiltered = useCallback(() => !isEmptyProductFilters(filters), [filters]);

    useEffect(() => {
        if (isBundleFiltered() && !filtered) {
            setFiltered(true);
        } else if (!isBundleFiltered() && filtered) {
            setFiltered(false);
        }
    }, [filtered, isBundleFiltered]);

    return (
        <BundleHeader
            title={bundle.title}
            bundle={bundle}
            filtered={filtered}
            onAddBundleToList={onAddBundleToList}
            onAddBundleToCart={onAddBundleToCart}
            onCreateNewListClicked={onCreateNewListClicked}
            orderlists={orderlists}
        />
    );
};

export default DetailHeader;
